import React from 'react'
import ReactDOM from 'react-dom/client'
import './shared/i18n' // initialize i18next (en/hi/mr) before the app renders
import './shared/fonts.css' // self-hosted Zilla Slab + Mulish for the storefront theme (no CDN)
import App from './App'
import ErrorBoundary from './shared/components/ErrorBoundary'
import { initAnalytics } from './shared/analytics'

initAnalytics() // gtag.js — prod builds only

// A rejected promise nobody awaited never reaches the ErrorBoundary — that catches renders, not
// async work — so it would otherwise vanish with no trace at all. One line makes it reachable
// over devtools, which is how a shopkeeper's phone actually gets debugged.
window.addEventListener('unhandledrejection', (e) => {
  console.error('[unhandled-rejection]', e.reason)
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
